// extracted by mini-css-extract-plugin
export var media = "styles-module--media--28458";
export var mediaCaption = "styles-module--mediaCaption--ec07e";
export var mediaContainer = "styles-module--mediaContainer--7943e";
export var mediaCredit = "styles-module--mediaCredit--43143";